import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import { ImageProps } from 'app/utilities/ImageProps';
import Config from '../../../Config';

type BackgroundVideoProps = {
  fallbackImageProps?: ImageProps;
  videoUrl: string;
  posterUrl?: string;
  displayControl?: boolean;
  iconControlImage?: string;
};

const BackgroundVideo = ({ fallbackImageProps, videoUrl, posterUrl, displayControl, iconControlImage }: BackgroundVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');
  const [isDisplayControl, setIsDisplayControl] = useState(false);
  const [isHideBtnControl, setIsHideBtnControl] = useState(false);
  const [mutedParam, setIsMutedParam] = useState(true);
  const { ref, inView, entry } = useInView();

  useEffect(() => {
    if (!entry) return;

    if (swiperIsStop || !inView) {
      videoRef.current?.pause();
      setSwiperAutoPlay('Start');
    } else if (inView) {
      videoRef.current?.play();
      setSwiperAutoPlay('Stop');
    }
  }, [inView, entry, videoRef, swiperIsStop]);

  const handleElementClick = () => {
    setIsMutedParam(false)
    setIsDisplayControl(displayControl);
    setIsHideBtnControl(true);
  }

  const videoRefCallback = useCallback((node: HTMLVideoElement) => {
    videoRef.current = node;
    ref(node);
  }, []);

  return (
    <>
      <HiddenStopAndStartButton className='' onClick={() => setSwiperIsStop((prevState) => !prevState)} swiperAutoPlay={swiperAutoPlay} />
      {videoUrl ? (
        <video className='BackgroundVideo' src={videoUrl} poster={posterUrl} autoPlay playsInline muted={mutedParam} loop ref={videoRefCallback} controls={isDisplayControl} />
      ) : fallbackImageProps?.src ? (
        <Image {...fallbackImageProps} className='BackgroundVideo' />
      ) : null}
      {displayControl && isHideBtnControl === false &&
        <div onClick={handleElementClick} className='control-button'>
          <Image src={iconControlImage} />
        </div>
      }
      <div className='HomepageHeadeCarousel__subtitle' />
    </>
  );
};

export default BackgroundVideo;
